import {
  LUZMO_TOKEN_ENDPOINT,
  LUZMO_REPORTS_ENDPOINT,
  LUZMO_EXPORT_REPORT_ENDPOINT,
  LUZMO_SCHEDULE_REPORT_ENDPOINT
} from 'config';
import { callApi, callApiBlob } from 'services/api';

export const fetchLuzmoEmbedToken = async () => {
  try {
    const body = await callApi(LUZMO_TOKEN_ENDPOINT, 'POST');
    const expiry = new Date(body?.expiry).getTime();

    if (!body?.authKey || !body?.authToken || !Number.isFinite(expiry) || expiry <= Date.now()) {
      throw new Error('The Insights API returned an invalid or expired embed token.');
    }

    return body; // { authKey, authToken, expiry }
  } catch (error) {
    const message = error?.message ||
      (typeof error?.error === 'string' ? error.error : null) ||
      'Unable to load the Luzmo embed token.';
    throw new Error(message);
  }
};

export const fetchLuzmoReports = async () => {
  try {
    // The authenticated gateway supplies the organization, not the browser.
    const body = await callApi(LUZMO_REPORTS_ENDPOINT);
    if (!Array.isArray(body?.reports)) {
      throw new Error('The reports API returned an invalid response.');
    }
    return body.reports;
  } catch (error) {
    throw new Error(error?.message || error?.error || 'Unable to load reports.');
  }
};

const parseFilename = (contentDisposition, fallback) => {
  const match = /filename="([^"]+)"|filename=([^;\s]+)/i.exec(contentDisposition || '');
  return match?.[1] || match?.[2] || fallback;
};

export const exportLuzmoReport = async ({ reportId, format }) => {
  try {
    const { body: blob, headers } = await callApiBlob(LUZMO_EXPORT_REPORT_ENDPOINT, 'POST', {
      reportId,
      format
    });
    return {
      blob,
      filename: parseFilename(headers['Content-Disposition'], `${reportId}.${format}`)
    };
  } catch (error) {
    throw new Error(error?.message || error?.error || 'Unable to export this report.');
  }
};

export const scheduleLuzmoReport = async ({
  reportId,
  frequency,
  format,
  email
}) => {
  try {
    return await callApi(LUZMO_SCHEDULE_REPORT_ENDPOINT, 'POST', {
      reportId,
      frequency,
      format,
      ...(email?.trim() ? { email: email.trim() } : {})
    });
  } catch (error) {
    throw new Error(error?.message || error?.error || 'Unable to schedule this report.');
  }
};
